// src/components/SearchBar.js
import React from 'react';
import { Form, Input, Button } from 'antd';

const SearchBar = ({ onSearch }) => {
    const onFinish = (values) => {
        onSearch('search=' + (values.search || ''));
    };

    return (
        <Form layout="inline" onFinish={onFinish} style={{ justifyContent: 'center', marginBottom: 24 }}>
            <Form.Item name="search" style={{ flex: 1 }}>
                <Input placeholder="Search products..." allowClear />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Search</Button>
            </Form.Item>
        </Form>
    );
};

export default SearchBar;
